import Market from '@root/core/src/models/market';
import PropTypes from '@root/vendor/prop-types';
import React, { useState } from '@root/vendor/react';
import iconHome from '@root/gatsby-contentful-core/src/assets/icons/homeowners.svg';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { METRICS } from '@root/joinroot.com/src/components/covid-driving';
import { stringifyDate } from '@root/joinroot.com/src/components/covid-driving/covid-driving-utils';
import { timeFormat } from 'd3-time-format';
import { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';

export const tooltipDateFormat = '%a, %B %d, %Y';

export default function Tooltip({
  point,
  metric,
  eventsFileData,
  stayHomeLabel,
}) {
  const [currentPointId, setCurrentPointId] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');

  const metricQuantity = parseFloat(point.data.yFormatted.toFixed(1));

  const METRICS_TO_TOOLTIP = {
    [METRICS.DRIVER_COUNT]: 'drivers per day',
    [METRICS.TRIP_COUNT]: 'trips per day',
    [METRICS.TRIP_MILES]: 'miles per day',
    [METRICS.TRIP_MINUTES]: 'minutes per day',
  };

  if (currentPointId !== point.id) { // If user hovers a new point...
    setCurrentPointId(point.id);
    const selectedDate = stringifyDate(point.data.x);

    setSelectedEvent(null); // Initially remove the current event
    Object.entries(eventsFileData.national) // but add a new event if there is one for that date.
      .filter(([date]) => date === selectedDate)
      .map(([date, event]) => setSelectedEvent(event)); // eslint-disable-line no-unused-vars
  }

  if (point.serieId === stayHomeLabel) { return null; } // This avoids displaying tooltip on stayAtHomeZone

  const dateFormat = timeFormat(tooltipDateFormat);
  const dateToDisplay = point.serieId.includes('2019')
    ? dateFormat(new Date('2019', point.data.x.getMonth(), point.data.x.getDate()))
    : point.data.xFormatted;

  return (
    <div css={styles.toolTipContainer}>
      <p css={styles.toolTipDate}>{dateToDisplay}</p>
      <p>{Market.MAPPING[point.serieId] || point.serieId}: {metricQuantity} {METRICS_TO_TOOLTIP[metric]}</p>

      {selectedEvent &&
        <div css={styles.eventContainer}>
          <p css={styles.eventText}>{selectedEvent}</p>
          {selectedEvent.includes('home') &&
            <img
              alt={'home icon'}
              css={styles.eventIcon}
              src={iconHome}
            />
          }
        </div>
      }
    </div>
  );
}

Tooltip.propTypes = {
  eventsFileData: PropTypes.shape({
    national: PropTypes.object,
  }),
  metric: PropTypes.string,
  point: PropTypes.object,
  stayHomeLabel: PropTypes.string,
};

const styles = StyleSheet.create({
  toolTipContainer: {
    background: Colors.white(),
    padding: '14px 22px',
    border: `1px solid ${Colors.gray40()}`,
    borderRadius: 6,
    boxShadow: `0 6px 20px -4px ${toRgba(Colors.black(), 0.25)}`,
    maxWidth: 250,
    fontSize: 12,
    lineHeight: '120%',
    textAlign: 'left',
  },
  toolTipDate: {
    marginBottom: 6,
    fontWeight: 'bold',
  },
  eventContainer: {
    display: 'flex',
    marginTop: 14,
  },
  eventText: {
    flexGrow: 1,
    color: Colors.gray50(),
  },
  eventIcon: {
    marginLeft: 12,
    alignSelf: 'flex-end',
  },
});
